import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../src/constants/premissions'
import { billSearchSearchSchema } from '../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../src/utils/routePermissions'

export const Route = createFileRoute('/bill/search')({
  validateSearch: (search) => billSearchSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.BILL,
    layout: 'menu',
  },
})
